import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Autocomplete, Box, Button, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DateRangePicker, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';
import { ArrowDropDown, ArrowDropUp, ArrowOutward, TrendingDown, TrendingUp } from '@mui/icons-material';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ApiDownloadExcel, ApiGetCategoryList, ApiGetStarRating, ApiGetStarRating2, ApiGetStarRatingForVenue, ApiGetStarRatingForVenue2 } from '../../apiService/Core/Apicall';
import { Images } from '../../global/GloblImages';
import GroupReport from '../../Components/Charts/GroupReport';
import chartlabel from '../../assets/images/styleimages/chartlabel.png'
import first from '../../assets/common/images/first.png'
import second from '../../assets/common/images/second.png'
import third from '../../assets/common/images/third.png'
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { RootState } from '../../global/config/store';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import { toast } from 'react-toastify';
import storage from '../../utils/storage';



function ReportStarRating() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [alignment, setAlignment] = React.useState('Competitors');
    const [startMonth, setStartMonth] = React.useState<any>(dayjs(selectedMonth).startOf('year'));
    const [endMonth, setEndMonth] = React.useState<any>(dayjs(selectedMonth));
    const { DownArrow, UpArrow } = Images()
    const [categorylist, setcategorylist] = useState<any>([])
    const [selectedcategory, setselectedcategory] = useState<string>(" ")
    const [starRating1, setstarRating1] = useState<any>([])
    const [starRating2, setstarRating2] = useState<any>([])
    const [selectedMarker, setSelectedMarker] = useState<any>(null);
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const mapRef = useRef<any>(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [industryAverage, setindustryAverage] = useState('');
    const userOtherData = JSON.parse(storage.getItem('userOtherData') || '{}');

    useEffect(() => {
        if (alignment === 'Competitors') {
            const Venuelist = async () => {
                try {
                    const clientEntityId: any = storage.getItem('clientEntityId');
                    const response2 = await ApiGetCategoryList(clientEntityId);
                    const categorylistitems = [
                        {
                            starRatingId: ' ',
                            starRatingDesc: "All"
                        },
                        ...response2.data
                    ]
                    setcategorylist(categorylistitems);
                    setselectedcategory(' ')
                } catch (error) {
                    console.error("Error fetching venue list:", error);
                }
            };
            Venuelist();
        }
    }, [alignment, clientEntity])

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ) => {
        newAlignment && setAlignment(newAlignment);
    };
    const containerStyle = {
        width: '100%',
        height: 'calc(100vh - 310px)'
    };

    // Example center point
    const center = useMemo(() => {
        if (!starRating2 || starRating2.length === 0) {
            return { lat: 0, lng: 0 }; // fallback
        }

        const total = starRating2?.reduce(
            (acc: any, item: any) => {
                const lat = parseFloat(item.lat);
                const lng = parseFloat(item.long);
                return {
                    lat: acc.lat + lat,
                    lng: acc.lng + lng
                };
            },
            { lat: 0, lng: 0 }
        );

        return {
            lat: total.lat / starRating2.length,
            lng: total.lng / starRating2.length
        };
    }, [starRating2, clientEntity]);

    useEffect(() => {
        const senddata = {

            s_month: startMonth && startMonth.month() + 1,
            s_year: startMonth && startMonth?.year(),
            e_month: endMonth && endMonth?.month() + 1,
            e_year: endMonth && endMonth?.year(),
            clientEntityId: storage.getItem('clientEntityId'),
            ...(selectedcategory && { categoryId: selectedcategory }),
            ...(userOtherData?.venueId && { venueId: userOtherData.venueId })
        }
        console.log("Sned Data", senddata)
        const data1 = async () => {
            const response = storage.getItem('userRole') === 'venueadmin' ? await ApiGetStarRatingForVenue(senddata) : await ApiGetStarRating(senddata)
            setstarRating1(response.data)
        }
        const data2 = async () => {
            const response = storage.getItem('userRole') === 'venueadmin' ? await ApiGetStarRatingForVenue2(senddata) : await ApiGetStarRating2(senddata)
            setstarRating2(response.data)
            setindustryAverage(response?.industryAverage)
        }
        if (alignment === 'Competitors') {
            data1()
        }
        else if (alignment === 'WithinGroup') {
            data2()
        }
    }, [alignment, selectedcategory, startMonth, endMonth, clientEntity])


    // const onLoad = useCallback((map: google.maps.Map) => {
    //     mapRef.current = map;

    //     if (starRating2 && starRating2.length > 0) {
    //         const bounds = new window.google.maps.LatLngBounds();
    //         starRating2.forEach((item: any) => {
    //             const lat = parseFloat(item.lat);
    //             const lng = parseFloat(item.long);
    //             if (!isNaN(lat) && !isNaN(lng)) {
    //                 bounds.extend({ lat, lng });
    //             }
    //         });
    //         map.fitBounds(bounds);
    //     }
    // },);

    useEffect(() => {
        if (mapLoaded && starRating2?.length > 0 && mapRef.current) {
            const bounds = new window.google.maps.LatLngBounds();
            starRating2.forEach((item: any) => {
                bounds.extend({
                    lat: parseFloat(item.lat),
                    lng: parseFloat(item.long),
                });
            });
            mapRef.current.fitBounds(bounds);
        }
    }, [mapLoaded, starRating2]);
    useEffect(() => {
        setEndMonth(dayjs(selectedMonth).startOf('month'))
    }, [selectedMonth])

    const handledownloadExcel = async () => {
        try {
            const query = `?reportType=starCompetitorRating&clientEntityId=${storage.getItem(
                "clientEntityId"
            )}&s_month=${startMonth.month() + 1}&s_year=${startMonth.year()}&e_month=${endMonth.month() + 1}&e_year=${endMonth.year()}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;

            const response = await ApiDownloadExcel(query);

            // Create Excel blob
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            if (blob.size === 0) {
                throw new Error("Empty Excel file.");
            }

            // Create download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;

            // Add a default filename
            link.setAttribute(
                "download",
                `StarRating.xlsx`
            );

            document.body.appendChild(link);
            link.click();

            // Clean up
            link.remove();
            URL.revokeObjectURL(url);
        } catch (error: any) {
            const message = error?.response?.message || error?.message;
            toast.error(message);
        }
    };


    const handleVenueDashboard = (venueId: string, venueName: string) => {
        if (!venueId) {
            return
        }
        const url = `/maindashboard/sitedashboard?v=${encodeURIComponent(venueId)}&n=${encodeURIComponent(venueName)}&s=${encodeURIComponent(selectedMonth)}`;
        window.open(url, '_blank'); // opens in new tab
    };

    return (
        <Box className='mt-3'>

            <Box className='d-flex align-items-center  flex-wrap justify-content-between'>
                <Box className="selected col-md-4  col-12 togglebutton  d-flex justify-content-md-start justify-content-center mb-0">
                    <ToggleButtonGroup
                        className="d-flex justify-content-start m-0 p-0"
                        exclusive
                        value={alignment}
                        onChange={handleChange}
                    >
                        <ToggleButton className="py-2 px-3 m-0" value="Competitors">
                            Competitors
                        </ToggleButton>
                        <ToggleButton className="py-2 px-3 m-0" sx={{ whiteSpace: 'nowrap' }} value="WithinGroup">
                            Within Group
                        </ToggleButton>

                    </ToggleButtonGroup>
                </Box>
                <Box className='col-12 col-md-8 d-flex gap-0 flex-wrap align-items-center justify-content-end'>
                    <Box className='col-md-6 col-12 gap-2 d-flex align-items-center justify-content-end'>
                        <Button className='btn-main px-3 w-auto' sx={{ whiteSpace: 'nowrap' }} onClick={() => { handledownloadExcel() }}>Download Excel</Button>
                        <FormControl sx={{width: 'fit-content', minWidth: '200px' }}>

                            <Autocomplete
                                className='text-dark'
                                options={categorylist || []}
                                getOptionLabel={(option) => option.starRatingDesc || ''}
                                value={categorylist.find((item: any) => item.starRatingId === selectedcategory) || null}
                                onChange={(event, newValue) => {
                                    setselectedcategory(newValue?.starRatingId || '');
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Category" sx={{ color: 'black !important' }} variant="outlined" />
                                )}

                                isOptionEqualToValue={(option, value) => option.starRatingId === value.starRatingId}
                            />
                        </FormControl>
                    </Box>
                    <Box justifyContent={{ xs: 'start', md: 'center' }} className='col-12 ps-2 col-md-6 d-flex align-itmes-center'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Box display="flex" minWidth={{ xs: '320px', md: '350px' }} gap={1}>
                                <DatePicker value={startMonth} className='col-grow'
                                    label="Start Month: "
                                    views={['month', 'year']}
                                    format="MMM-YY"
                                    maxDate={endMonth}
                                    onChange={(e) => { setStartMonth(e); }}
                                    slots={{
                                        openPickerIcon: ArrowDropDownIcon,
                                    }}
                                />
                                <DatePicker value={endMonth} className='col-grow'
                                    label="End Month:"
                                    views={['month', 'year']}
                                    format="MMM-YY"
                                    minDate={startMonth}
                                    onChange={(e: any) => {
                                        const isoString = e?.startOf('month').toISOString();
                                        dispatch(setSelectedMonth(isoString));
                                    }} slots={{
                                        openPickerIcon: ArrowDropDownIcon,
                                    }}
                                />
                            </Box>
                        </LocalizationProvider>
                    </Box>
                </Box>
            </Box>

            {alignment === 'Competitors' && (<>
                <Box className='mt-3 d-flex  flex-wrap justify-content-between gap-2'>
                    <Box className="col-md-6 p-0 col-12 d-flex flex-wrap">
                        <Box className="w-100 d-flex p-3 border-20 bg-main align-items-start justify-content-between">
                            <Box className='d-flex flex-column gap-5 align-items-start justify-content-between h-100'>
                                <Typography variant='body2' className='txt-white'>Your Current Ranking out of {starRating1?.rankOutof}</Typography>
                                <Typography className='fw-bold txt-white' variant='h3'>{String(starRating1?.yourBusinessRank).length === 1 && 0}{starRating1?.yourBusinessRank}</Typography>
                            </Box>
                            {/* <IconButton className='bg-white send-btn p-4'>
                                <ArrowOutward className='txt-white' />
                            </IconButton> */}
                        </Box>
                        <Box mt={{ xs: 4, md: 3 }} className='d-flex  align-items-stretch justify-content-between'>
                            <Box sx={{ cursor: 'pointer' }} onClick={() => { handleVenueDashboard(starRating1?.topPerformingVenue?.venueId, starRating1?.topPerformingVenue?.venueName) }} position='relative' width='48%' className='border hover border-20 p-3 d-flex flex-wrap align-items-end justify-content-between'>
                                <Box width={{ xs: "100%", md: "48%" }} className='d-flex gap-3 flex-column  align-items-start justify-content-between'>
                                    <Typography className='mb-4 w-50'>Top Performing</Typography>
                                    <Typography className='fw-bold' variant='h4'>{starRating1?.topPerformingVenue?.rank ? "#" + starRating1?.topPerformingVenue?.rank : 'N/A'}</Typography>
                                </Box>
                                <Box width={{ xs: "100%", md: "48%" }} className='d-flex gap-2 flex-column align-items-start align-items-md-end justify-content-end'>
                                    <Typography className='text-third text-start fw-bolder' variant='h6'>{starRating1?.topPerformingVenue?.venueName ?? 'N/A'}</Typography>
                                    <Typography textAlign={{ xs: 'start', md: 'end' }} width='100%' variant='caption'>Site ranking out of {starRating1?.topPerformingVenue?.rankOutOf ?? 'N/A'}{selectedcategory !== ' ' && <span> in <span className='text-third'>{starRating1?.topPerformingVenue?.starRatingDesc ?? 'N/A'}</span></span>}</Typography>
                                </Box>
                                <Box component='img' width='30%' maxWidth='40px' className='down-img' src={UpArrow}></Box>
                            </Box>
                            <Box sx={{ cursor: 'pointer' }} onClick={() => { handleVenueDashboard(starRating1?.bottomPerformingVenue?.venueId, starRating1?.bottomPerformingVenue?.venueName) }} position='relative' width='48%' className='border border-20 hover p-3 d-flex flex-wrap align-items-end justify-content-between'>
                                <Box width={{ xs: "100%", md: "48%" }} className='d-flex gap-3 flex-column align-items-start justify-content-between'>
                                    <Typography className='mb-4'>Below Benchmark</Typography>
                                    <Typography className='fw-bold' variant='h4'>{starRating1?.bottomPerformingVenue?.rank ? "#" + starRating1?.bottomPerformingVenue?.rank : 'N/A'}</Typography>
                                </Box>
                                <Box width={{ xs: "100%", md: "48%" }} className='d-flex gap-2 flex-column align-items-start hover align-items-md-end justify-content-end'>
                                    <Typography className='text-secondary text-start fw-bolder' variant='h6'>{starRating1?.bottomPerformingVenue?.venueName ?? 'N/A'}</Typography>
                                    <Typography textAlign={{ xs: 'start', md: 'end' }} width='100%' variant='caption'>Site ranking out of {starRating1?.bottomPerformingVenue?.rankOutOf ?? 'N/A'}{selectedcategory !== ' ' && <span> in <span className='text-third'>{starRating1?.topPerformingVenue?.starRatingDesc ?? 'N/A'}</span></span>}</Typography>
                                </Box>
                                <Box component='img' width={{ xs: '40%', md: "25%" }} maxWidth='60px' className='down-img' src={DownArrow}></Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box className="flex-grow-1">
                        <Box position='relative' className='bg-light-main border-10 p-3'>
                            <Box className="text-left" width={{ xs: '25%', md: 'auto' }}>
                                <Typography fontSize={{ md: '20px', xs: '14px' }} fontWeight='bold' whiteSpace={{ xs: 'nowrap' }} className="font-bold" >Your Overall Ranking</Typography>
                            </Box>
                            {(starRating1?.industryAverage?.clientEntityAverages) ? (<><GroupReport diffbarcolor={false} totalheight={280} barWidth={0} horizontal={false}
                                xAxis={
                                    ["Your Group", "Industry Std",
                                        ...(starRating1 && starRating1?.industryAverage?.clientEntityAverages.slice(0, 3).map((item: any, index: number) => `Competitor ${index + 1}`))]}
                                yAxis={
                                    [parseFloat(starRating1 && starRating1?.yourBusinessAverage).toFixed(2),
                                    parseFloat(starRating1 && starRating1?.industryAverage?.industryAverage).toFixed(2),
                                    ...(starRating1 && starRating1?.industryAverage?.clientEntityAverages.slice(0, 3).map((item: any) => parseFloat(item?.average).toFixed(2)))]} />
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        bottom: '-10px',
                                        left: '50%',
                                        transform: 'translate(-50%, 0%)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Box
                                        px={5}
                                        sx={{ backgroundImage: `url(${chartlabel})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }}
                                    >
                                        <Typography variant='caption' sx={{ whiteSpace: 'nowrap' }}>
                                            {/* Above Industry average by: {((parseFloat(starRating1 && starRating1?.industryAverage?.industryAverage - starRating1?.yourBusinessAverage) / starRating1?.industryAverage?.industryAverage) * 100).toFixed(2)}% */}
                                            {starRating1?.yourBusinessAverage - starRating1?.industryAverage?.industryAverage < 0 ? 'Below' : ' Above'} Industry average by: {(Math.abs(parseFloat(starRating1 && starRating1?.yourBusinessAverage - starRating1?.industryAverage?.industryAverage))).toFixed(2)}
                                        </Typography>
                                    </Box>
                                </Box>
                            </>
                            ) : <Typography className='text-center my-5' variant='h5'>No Data Found</Typography>}
                        </Box>
                    </Box>
                </Box>
                <Box>
                    <Box className='d-flex flex-wrap align-items-center justify-content-start gap-3 mt-3 ms-0 ms-md-3'>
                        {starRating1.yourVenues && starRating1?.yourVenues.map((item: any, index: number) => (
                            <Box sx={{ cursor: 'pointer' }} onClick={() => { handleVenueDashboard(item?.venueId, item?.venueName) }} width={{ xs: "100%", md: '49%' }} className='border border-10 p-2  d-flex align-items-center hover justify-content-between'>
                                <Box className='d-flex align-items-center gap-2'>
                                    <Box className={`border border-10 px-3 py-2 bg-light-main ${index > 2 && 'pt-2'}`}>
                                        {item?.rank === 1 ? <Box component='img' src={first} /> :
                                            item?.rank === 2 ? <Box component='img' height={'40px'} src={second} /> :
                                                item?.rank === 3 ? <Box component='img' height={'40px'} src={third} /> :
                                                    item?.rank
                                        }
                                    </Box>
                                    <Box>
                                        <Typography className='fw-bold' variant='body1'>{item.venueName}</Typography>
                                        <Box className='d-flex align-itmes-center gap-1'> {(parseFloat(item.avgStarRating) - item?.industryAvg) >= 0 ? <TrendingUp /> : <TrendingDown />}
                                            <Typography variant='caption'>{(parseFloat(item.avgStarRating) - item?.industryAvg) >= 0 ? `Above industry by ${(parseFloat(item.avgStarRating) - item?.industryAvg).toFixed(2)}` : `Below industry by ${(parseFloat(item.avgStarRating) - item?.industryAvg).toFixed(2)}`} </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                <Typography className='fw-bold text-main' variant='h5'>{parseFloat(item.avgStarRating).toFixed(2)}</Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </>)}
            {alignment === 'WithinGroup' && (
                <Box className='mt-3 d-flex flex-wrap gap-2 align-items-start justify-content-between'>
                    <Box className="col-12 col-md-6">
                        {starRating2 && (
                            <LoadScript googleMapsApiKey="AIzaSyCmcI0swO1MNjQYUD7qktNT78-cDMBoi44">
                                <GoogleMap mapContainerStyle={containerStyle}
                                    onLoad={(map) => {
                                        mapRef.current = map;
                                        setMapLoaded(true);
                                    }}
                                    center={center} zoom={15}>
                                    {starRating2 && starRating2?.map((item: any, index: number) => (
                                        <Marker
                                            key={index}
                                            position={{ lat: parseFloat(item.lat), lng: parseFloat(item.long) }}
                                            onClick={() => setSelectedMarker(item)}

                                        />
                                    ))}

                                    {selectedMarker && selectedMarker.lat && selectedMarker.long && (
                                        <InfoWindow
                                            position={{
                                                lat: parseFloat(selectedMarker.lat),
                                                lng: parseFloat(selectedMarker.long)
                                            }}
                                            onCloseClick={() => setSelectedMarker(null)}
                                        >
                                            <div className='m-0 p-0'>
                                                <p className='m-0 p-0'>{selectedMarker.venueName || "No Name"}</p>
                                            </div>
                                        </InfoWindow>
                                    )}
                                </GoogleMap>
                            </LoadScript>
                        )}
                    </Box>
                    <Box className='flex-grow-1'>
                        {starRating2 && starRating2?.map((item: any, index: number) => (
                            <Box sx={{ cursor: 'pointer' }} onClick={() => { handleVenueDashboard(item?.venueId, item?.venueName) }} className='border border-10 hover p-2 mb-2 d-flex align-items-center justify-content-between'>
                                <Box className='d-flex align-items-center gap-2'>
                                    <Box className={`border border-10 px-3 py-1 bg-light-main ${index > 2 && 'pt-2'}`}>
                                        {item?.rank === 1 ? <Box component='img' src={first} /> :
                                            item?.rank === 2 ? <Box component='img' height={'40px'} src={second} /> :
                                                item?.rank === 3 ? <Box component='img' height={'40px'} src={third} /> :
                                                    item?.rank
                                        }
                                    </Box>
                                    <Box>
                                        <Typography className='fw-bold' variant='body1'>{item.venueName}</Typography>
                                        <Box className='d-flex align-itmes-center gap-1'>{(parseFloat(item.avgStarRating) - parseFloat(industryAverage)) >= 0 ? <TrendingUp /> : <TrendingDown />}
                                            <Typography variant='caption'>{(parseFloat(item.avgStarRating) - parseFloat(industryAverage)) >= 0 ? `Above industry by ${(parseFloat(item.avgStarRating) - parseFloat(industryAverage)).toFixed(2)}` : `Below industry by ${(parseFloat(item.avgStarRating) - parseFloat(industryAverage)).toFixed(2)}`}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                <Typography className='fw-bold text-main' variant='h5'>{parseFloat(item.avgStarRating).toFixed(2)}</Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            )}

        </Box>
    )
}

export default ReportStarRating
